import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Sidebar from '../Sidebar/Sidebar';
import { TextField, Box, Typography } from '@mui/material';
import { useState } from 'react';
import { FolderKanban, CalendarArrowDown,CalendarArrowUp ,User,Phone,SquareCheck ,ArrowDownToLine ,ChevronUp ,ChevronDown,Clapperboard,CalendarClock,Search     } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import EmployeeTicket from './EmployeeTicket';
import Table2 from './Table2';
import TicketDashboard from './TicketDashboard';
const columns = [
  { field: 'id', headerName: 'S.No' },
  { field: 'employeename', headerName: 'Employee Name', flex: 1 },
  { field: 'employeeid', headerName: 'Employee ID', flex: 1 },
  { field: 'tickettype', headerName: 'Ticket Type', flex: 1 },
  { field: 'ticketcreator', headerName: 'Ticket Creator', flex: 1 },
  { field: 'status', headerName: 'Status', flex: 1 },
  { field: 'createddate', headerName: 'Created Date', flex: 1 },
  { field: 'updateddate', headerName: 'Updated Date', flex: 1 },
];

const allRows = [
  {
    id: 1,
    employeename: 'Jon Snow',
    employeeid: 'EMP001',
    tickettype: 'Promotion',
    ticketcreator: 'Admin',
    status: 'Open',
    createddate: '2025-04-10',
    updateddate: '2025-04-11',
  },
  {
    id: 2,
    employeename: 'Cersei Lannister',
    employeeid: 'EMP002',
    tickettype: 'Promotion',
    ticketcreator: 'User1',
    status: 'In Progress',
    createddate: '2025-04-08',
    updateddate: '2025-04-10',
  },
  {
    id: 3,
    employeename: 'Jaime Lannister',
    employeeid: 'EMP003',
    tickettype: 'Termination',
    ticketcreator: 'Admin',
    status: 'Closed',
    createddate: '2025-03-30',
    updateddate: '2025-04-05',
  },
  {
    id: 4,
    employeename: 'Arya Stark',
    employeeid: 'EMP004',
    tickettype: 'Termination',
    ticketcreator: 'QA_Team',
    status: 'Open',
    createddate: '2025-04-02',
    updateddate: '2025-04-09',
  },
  {
    id: 5,
    employeename: 'Daenerys Targaryen',
    employeeid: 'EMP005',
    tickettype: 'Demotion',
    ticketcreator: 'Developer1',
    status: 'In Progress',
    createddate: '2025-04-01',
    updateddate: '2025-04-07',
  },
  {
    id: 6,
    employeename: 'Tyrion Lannister',
    employeeid: 'EMP006',
    tickettype: 'Demotion',
    ticketcreator: 'PM_Team',
    status: 'Closed',
    createddate: '2025-03-29',
    updateddate: '2025-04-04',
  },
  {
    id: 7,
    employeename: 'Sansa Stark',
    employeeid: 'EMP007',
    tickettype: 'Promotion',
    ticketcreator: 'Tester2',
    status: 'Open',
    createddate: '2025-04-05',
    updateddate: '2025-04-10',
  },
  {
    id: 8,
    employeename: 'Bran Stark',
    employeeid: 'EMP008',
    tickettype: 'Demotion',
    ticketcreator: 'ProductOwner',
    status: 'In Progress',
    createddate: '2025-04-06',
    updateddate: '2025-04-08',
  },
  {
    id: 9,
    employeename: 'Brienne of Tarth',
    employeeid: 'EMP009',
    tickettype: 'Demotion',
    ticketcreator: 'User2',
    status: 'Open',
    createddate: '2025-04-03',
    updateddate: '2025-04-06',
  },
  {
    id: 10,
    employeename: 'Samwell Tarly',
    employeeid: 'EMP010',
    tickettype: 'Promotion',
    ticketcreator: 'Admin',
    status: 'Closed',
    createddate: '2025-03-28',
    updateddate: '2025-04-02',
  },
];


export default function TableDetails() {
  const [searchText, setSearchText] = React.useState('');
  const [filteredRows, setFilteredRows] = React.useState(allRows);
// ...............
const [sortedData, setSortedData] = useState([]);
const [error, setError] = useState(null);
const [datas, setData] = useState({ Projects: [ {
    id: 1,
    employeename: 'Jon Snow',
    employeeid: 'EMP001',
    tickettype: 'Promotion',
    ticketcreator: 'Admin',
    status: 'Open',
    createddate: '2025-04-10',
    updateddate: '2025-04-11',
  },
  {
    id: 2,
    employeename: 'Cersei Lannister',
    employeeid: 'EMP002',
    tickettype: 'Promotion',
    ticketcreator: 'User1',
    status: 'In Progress',
    createddate: '2025-04-08',
    updateddate: '2025-04-10',
  },
  {
    id: 3,
    employeename: 'Jaime Lannister',
    employeeid: 'EMP003',
    tickettype: 'Termination',
    ticketcreator: 'Admin',
    status: 'Closed',
    createddate: '2025-03-30',
    updateddate: '2025-04-05',
  },
  {
    id: 4,
    employeename: 'Arya Stark',
    employeeid: 'EMP004',
    tickettype: 'Termination',
    ticketcreator: 'QA_Team',
    status: 'Open',
    createddate: '2025-04-02',
    updateddate: '2025-04-09',
  },
  {
    id: 5,
    employeename: 'Daenerys Targaryen',
    employeeid: 'EMP005',
    tickettype: 'Demotion',
    ticketcreator: 'Developer1',
    status: 'In Progress',
    createddate: '2025-04-01',
    updateddate: '2025-04-07',
  },
  {
    id: 6,
    employeename: 'Tyrion Lannister',
    employeeid: 'EMP006',
    tickettype: 'Demotion',
    ticketcreator: 'PM_Team',
    status: 'Closed',
    createddate: '2025-03-29',
    updateddate: '2025-04-04',
  },
  {
    id: 7,
    employeename: 'Sansa Stark',
    employeeid: 'EMP007',
    tickettype: 'Promotion',
    ticketcreator: 'Tester2',
    status: 'Open',
    createddate: '2025-04-05',
    updateddate: '2025-04-10',
  },
  {
    id: 8,
    employeename: 'Bran Stark',
    employeeid: 'EMP008',
    tickettype: 'Demotion',
    ticketcreator: 'ProductOwner',
    status: 'In Progress',
    createddate: '2025-04-06',
    updateddate: '2025-04-08',
  },
  {
    id: 9,
    employeename: 'Brienne of Tarth',
    employeeid: 'EMP009',
    tickettype: 'Demotion',
    ticketcreator: 'User2',
    status: 'Open',
    createddate: '2025-04-03',
    updateddate: '2025-04-06',
  },
  {
    id: 10,
    employeename: 'Samwell Tarly',
    employeeid: 'EMP010',
    tickettype: 'Promotion',
    ticketcreator: 'Admin',
    status: 'Closed',
    createddate: '2025-03-28',
    updateddate: '2025-04-02',
  },
] });
const [searchData, setSearchData] = useState("");
const [selectedField, setSelectedField] = useState("");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
const [selectedStatuses, setSelectedStatuses] = useState([]);
const [currentPa, setCurrentPa] = useState(0);
const [totalData, setTotalData] = useState(0);
const [searchTerm, setSearchTerm] = useState("");
const [isPopupOpen, setIsPopupOpen] = useState(false);
const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const [statusFilter, setStatusFilter] = useState([]); 
const [debouncedSearch, setDebouncedSearch] = useState(searchData); 
const [noffset, setNoffset] = useState("");
const [nextToken, setNextToken] = useState(null);
const [hasMoreRecords, setHasMoreRecords] = useState(false);
const [sortKey, setSortKey] = useState('');
const [sortOrder, setSortOrder] = useState('asc');
const [loading, setLoading] = useState(false);
// .......................
const navigate = useNavigate();
const handleRow = (id) => {
  navigate(`/home`);
};
  const handleSort = (field) => {
    const newSortOrder = sortKey === field && sortOrder === "asc" ? "desc" : "asc";

    const sorted = [...sortedData].sort((a, b) => {
      const valueA = a.Task_Details[field];
      const valueB = b.Task_Details[field];

      if (typeof valueA === "string") {
        return newSortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }
      return newSortOrder === "asc" ? valueA - valueB : valueB - valueA;
    });}
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = allRows.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(value)
      )
    );
    setFilteredRows(filtered);
  };

  

  return (
    <Sidebar>
     {/* <Table2/> */}
     <TicketDashboard/>
    </Sidebar>
  );
}
